import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';

const Dashboard: React.FC = () => {
  const user = authService.getCurrentUser();
  const navigate = useNavigate();

  const handleStartWizard = () => {
    // Navigate to the wizard with user data
    navigate('/wizard', { 
      state: { 
        userData: {
          firstName: user?.firstName,
          lastName: user?.lastName,
          email: user?.email,
          // Add any other relevant user data you want to pre-populate
        }
      }
    });
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 2,
          background: 'white',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome, {user?.firstName} {user?.lastName}!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          This is your personal dashboard where you can manage your account and view your information.
        </Typography>
        
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleStartWizard}
          sx={{ mt: 2 }}
        >
          Start Tax Onboarding
        </Button>
      </Paper>
    </Box>
  );
};

export default Dashboard; 